import actionTypes from '../actions/actionTypes';

export default function billReducer(state = {}, { type, data }) {
  let newState = null;

  switch (type) {
    case actionTypes.SET_BILLS:
      newState = {
        ...state,
        bills: data,
      };
      break;
    case actionTypes.EMPTY_BILLS:
      newState = {
        ...state,
        bills: [],
      };
      break;
    default:
      newState = state;
      break;
  }

  return newState;
}
